export const enum UserContestAssociation {
  ENTERED = 'ENTERED',
  CREATED = 'CREATED',
  COMBINED = 'COMBINED',
}
